import React from "react";
import Helmet from "react-helmet";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface MetaProps extends RouteComponentProps {
  title?: string;
  description?: string;
  keywords?: string | string[];
  author?: string;
  type?: string;
  imageUrl?: string;
  url?: string;
}

const Meta: React.StatelessComponent<MetaProps> = ({
  title,
  description,
  keywords,
  author,
  type,
  imageUrl,
  location,
  url = location.pathname,
}) => {
  const host = window.location.origin;
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && (
        <meta name="keywords" content={Array.isArray(keywords) ? keywords.join(",") : keywords} />
      )}
      {author && <meta name="author" content={author} />}
      {description && <meta property="og:description" content={description} />}
      {type && <meta property="og:type" content={type} />}
      {imageUrl && <meta property="og:image" content={`${host}${imageUrl}`} />}
      {imageUrl && <meta name="twitter:card" content="summary_large_image" />}
      {url && <meta property="og:url" content={`${host}${url}`} />}
    </Helmet>
  );
};

export default withRouter(Meta);
